import React, { useEffect, useState, useCallback, useContext } from "react";
import QuoteHeader from "../Layout/QuoteHeader";
import QuickAdd from "../QuickAdd/QuickAdd";
import ItemList from "../Items/ItemList";
import useHttp from "../../hooks/use-http";
import QuoteRequestDetails from "../AdditionalInformation/QuoteRequestDetails";
import RequestForQuote from "./RequestForQuote";
import Account from "../Account/Account";
import { useParams, useActionData } from "react-router-dom";
import AppContext from "../../store/app-context";
import parse from "html-react-parser";
import AuthContext from "../../store/auth-context";
import { parseCookies } from "nookies";
import _ from "lodash";

import styles from "./RFQHome.module.css";
import QuoteDetails from "../QuoteDetails/QuoteDetails";
import QuoteDetailsNewBrand from "../QuoteDetails/QuoteDetailsNewBrand";
import { SetAnalyticsData } from '../../util/SetAnalyticsData';

const RFQHome = () => {
  const appCtx = useContext(AppContext);
  const authCtx = useContext(AuthContext);

  sessionStorage.removeItem("webReference");
  sessionStorage.removeItem("acctInfo");
  sessionStorage.removeItem("quote");
  sessionStorage.removeItem("submittedWebRef");

  let label_browseCatalog = 'Browse Catalog';
  let label_useQuickAdd = 'or use the Quick Add feature above to add items.';
  let Price_Error = 'The account price is currently unavailable. When available, it will be charged to your account if the account price is lower than the displayed price.<br />Please continue to place your order.';

  if(appCtx && appCtx.bioradResources){
    label_browseCatalog = appCtx.bioradResources.Browse_Catalog1 ? appCtx.bioradResources.Browse_Catalog1 : 'Browse Catalog';
    label_useQuickAdd = appCtx.bioradResources.Browse_Oligo_Catalog2 ? appCtx.bioradResources.Browse_Oligo_Catalog2 : 'or use the Quick Add feature above to add items.';
    Price_Error = appCtx.bioradResources.Price_Error ? appCtx.bioradResources.Price_Error : 'The account price is currently unavailable. When available, it will be charged to your account if the account price is lower than the displayed price.<br />Please continue to place your order.';
  }

  const exsistCookies = parseCookies();

  const [quote, setQuote] = useState();
  const [itemList, setItemList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isEmptyQuote, setIsEmptyQuote] = useState(false);
  const [isAPIError, setIsAPIError] = useState(false);
  const [quickAddErrorMsg, setQuickAddErrorMsg] = useState();
  const [isRFQButtonClicked, setIsRFQButtonClicked] = useState(false);
  const [showQuoteHistory, setShowQuoteHistory] = useState(false);
  const [errorMsg, setErrorMsg] = useState('Error fetching data...');
  const [itemChanges, setItemChanges] = useState([]);
  const [acctInfo, setAcctInfo] = useState();

  const actionResponse = useActionData();

  const { webRef } = useParams();

  const getRFQEndPoint = webRef ? "/quoteservices/rfqs/rfq/"+webRef : "/quoteservices/rfqs/rfq";
  const { isLoadingGetQuote, errorGetQuote, sendRequest: getQuoteRequest } = useHttp();

  const onItemChange = (itemId, qty, action) => {
    const item = {};
    item['itemId'] = itemId;
    item['qty'] = qty;
    let itemFound = false;
    if("add" === action) {
      itemChanges.forEach(item => {
        if(item.itemId === itemId){
          item.qty = qty;
          itemFound = true;
        }
      })
      if(itemFound) {
        setItemChanges([...itemChanges]);
      }
      else{
        setItemChanges([...itemChanges, item]);
      }
    }
    if("delete" === action){
      setItemChanges((current) => current.filter((item) => item.itemId !== itemId));
    }

  }

  const itemFormSubmitHandler = useCallback(async (updatedItems, webReference) => {
    setQuickAddErrorMsg('')
    if(!updatedItems || updatedItems.length < 0){
      return;
    }
    setIsLoading(true);
    const setQuoteData = (quoteData) => {
      setQuote(quoteData);
      const quoteItems = quoteData.quoteLineEntityList ? quoteData.quoteLineEntityList : [];
      setItemList(quoteItems);
      setQuickAddErrorMsg('');
      setItemChanges([]);
      setIsLoading(false);
    }
    let itemIds = '';
    let qtys = '';
    updatedItems.forEach((item) => {
        itemIds += item.itemId + ',';
        qtys += item.qty + ',';
    })
    const itemUpdateURL = "/quoteservices/rfqs/items/" + webReference + "?itemIds=" + itemIds + "&qtys=" + qtys + "&pricing=y";
    const response = await fetch(itemUpdateURL, { method: 'post', headers: {'Content-type': 'application/text'}} );

    if (!response.ok) {
      const data = await response.json();
      if(data && data.status === 'fail'){
        setQuickAddErrorMsg(data.message);
      }
      setIsLoading(false);
    }else{
      const data = await response.json();
      if(data && data.status === 'fail'){
        setQuickAddErrorMsg(data.message);
      }else{
        setQuoteData(data);
      }
    }
    setIsLoading(false);
  },[]);

  const addItemHandler = useCallback(async (item) => {
    setIsLoading(true);
    setQuickAddErrorMsg('')
    const setQuoteData = (quoteData) => {
      setQuote(quoteData);
      const quoteItems = quoteData.quoteLineEntityList ? quoteData.quoteLineEntityList : [];
      setItemList(quoteItems);
      quoteData.addProducterrorMessage && quoteData.addProducterrorMessage !== '' && setQuickAddErrorMsg(quoteData.addProducterrorMessage);
      //setItemChanges([]);
      setIsLoading(false);
    }

    let addItemServiceURL = '/quoteservices/rfqs/add?AddToCartProductID='+ item.sku + '&quantity=' + item.quantity + '&directAdd=Y';
    if(item.webRef){
      addItemServiceURL = '/quoteservices/rfqs/rfq/'+item.webRef+'/item?AddToCartProductID='+ item.sku + '&quantity=' + item.quantity + '&directAdd=Y';
    }
    const response = await fetch(addItemServiceURL, { method: 'post', headers: {'Content-type': 'application/text'}} );

    if (!response.ok) {
      //throw new Error("Request failed!");
      //setIsAPIError(true);
      setIsLoading(false);
      const data = await response.json();
      if(data && data.status === 'fail'){
        setQuickAddErrorMsg(data.message);
      }
    }else{
      const data = await response.json();
      if(data && data.status === 'fail'){
        setQuickAddErrorMsg(data.message);
      }else{
        setQuoteData(data);
      }
    }
    setIsLoading(false);
  },[]);

  const deleteItemHandler = useCallback(async (itemId, webReference) => {
    setIsLoading(true);
    setQuickAddErrorMsg('')
    const setQuoteData = (quoteData) => {
      setQuote(quoteData);
      const quoteItems = quoteData.quoteLineEntityList ? quoteData.quoteLineEntityList : [];
      setItemList(quoteItems);
      setQuickAddErrorMsg('');
      setItemChanges((current) => current.filter((item) => item.itemId !== itemId));
      setIsLoading(false);
    }
    const deleteItemServiceURL = '/quoteservices/rfqs/item/'+ webReference + '/' + itemId;
    const response = await fetch(deleteItemServiceURL, { method: 'delete', headers: {'Content-type': 'application/text'}} );

    if (!response.ok) {
      //throw new Error("Request failed!");
      //setIsAPIError(true);
      setIsLoading(false);
      const data = await response.json();
      if(data && data.status === 'fail'){
        setQuickAddErrorMsg(data.message);
      }
    }else{
      const data = await response.json();
      if(data && data.status === 'fail'){
        setQuickAddErrorMsg(data.message);
      }else{
        setQuoteData(data);
      }
    }
    setIsLoading(false);
  },[]);

  useEffect(() =>{
    if(authCtx.isLoggedIn || exsistCookies.quoteAnon){
      setIsLoading(true);
      const setQuoteData = (quoteData) => {
        setQuote(quoteData);
        const quoteItems = quoteData.quoteLineEntityList ? quoteData.quoteLineEntityList : [];
        setItemList(quoteItems);
        setItemChanges([]);
        setIsLoading(false);
      }
      //getQuoteHandler();
      //const accountParams = accountInfo ? new URLSearchParams(accountInfo) : "";
      getQuoteRequest(
          { url: getRFQEndPoint },
          setQuoteData, 'json'
        ).catch((error)=>{
          if(error && error.message){
            setErrorMsg(error.message);
          }
        setIsAPIError(true);
        setIsLoading(false);
      });

      //setIsLoading(false);
    }
    if(isLoading) {
      setIsLoading(false);
    }
  },[authCtx.isLoggedIn, exsistCookies.quoteAnon]);

  // Adobe Analytics: userView and pageView
  SetAnalyticsData();

  // Adobe Analytics: quoteFormInit
  useEffect(() => {
    if (isLoading) return
    if (quote && quote.webReference) {
      window.digitalData = window.digitalData || []
      window.digitalData.push({
        event: 'quoteFormInit',
        quote: { id: quote && quote.webReference
          ? quote.webReference
          : "" }
      })
      // console.log('adobe - quoteFormInit', window.digitalData)
    }

  }, [isLoading])

  const onRFQButtonClicked=()=>{
    setIsRFQButtonClicked(true);
  }

  const accountChangeHandler = useCallback(async (accountDetails, webReference) => {
    setAcctInfo(accountDetails);
    setIsLoading(true);
    setQuickAddErrorMsg('')
    const setQuoteData = (quoteData) => {
      setQuote(quoteData);
      const quoteItems = quoteData.quoteLineEntityList ? quoteData.quoteLineEntityList : [];
      setItemList(quoteItems);
      setQuickAddErrorMsg('');
      setItemChanges([]);
      setIsLoading(false);
    }

    const filteredAccountDetails = _.cloneDeep(accountDetails);

    if(filteredAccountDetails && filteredAccountDetails.shipAddress){
      delete filteredAccountDetails['shipAddress'];
    }

    const accountParams = filteredAccountDetails ? new URLSearchParams(filteredAccountDetails).toString().replaceAll('%27',' ') : "";

    const accountUpdateURL = (webReference ? "/quoteservices/rfqs/rfq/" + webReference : "/quoteservices/rfqs/rfq") + '?' + accountParams;
    getQuoteRequest(
      { url: accountUpdateURL, method: 'POST'},
      setQuoteData, 'json'
    ).catch((error)=>{
      if(error && error.message){
        setErrorMsg(error.message);
      }
      setIsAPIError(true);
      setIsLoading(false);
    });

  },[]);


  if (isRFQButtonClicked) {
    return (
      <div>
        <QuoteRequestDetails quote={quote} />
      </div>
    );
  }

  const newBrandStyle =
    exsistCookies.rebrandEnabled ??
    appCtx?.envProp?.react_app_new_brand_style ??
    false;

  if (quote && (quote.integrationStatus || (quote.quoteStatus && quote.quoteStatus !== "Not Submitted"))) {
    return (
      <div>
        {newBrandStyle === 'true' ? <QuoteDetailsNewBrand  quote={quote}/> : <QuoteDetails quote={quote} />}
      </div>
    );
  }

  return (
    <>
      <div className={styles.RFQ}>

        {quote && quote.errorMessage && quote.errorMessage === 'Price_Error' && (
            <div className={styles.errorMsgs}>
              <span className={styles.bioicons_circle_exclamation}></span>
              <p>{parse(Price_Error)}</p>
            </div>
        )}
        <QuoteHeader quote={quote} isLoading={isLoading}/>
        <div className={styles["container-wrapper"]}>
          {actionResponse && <span>********************</span>}
          <div className={styles["content-quick-cart-module"]}>
            <QuickAdd onAddItem={addItemHandler} errorMsg={quickAddErrorMsg} quote={quote}/>
            {!isAPIError && itemList && itemList.length > 0 && (
              <ItemList
                quote={quote}
                isEditable={true}
                onItemChange={onItemChange}
                itemFormSubmitHandler={itemFormSubmitHandler}
                itemChanges={itemChanges}
                deleteItemHandler={deleteItemHandler}
              />
            )}
            {!isLoading && !isAPIError && itemList && itemList.length === 0 && (
              <p><a href='/' className={styles.btnlinkU}>{label_browseCatalog}</a>&nbsp;{label_useQuickAdd}</p>

            )}
            {isLoading && !isAPIError && <p className={styles.loading_ring}></p>}
            {isAPIError && <p>{errorMsg}</p>}
          </div>
          <div className="right-col-wrapper">
            <Account accountChangeHandler={accountChangeHandler} quote={quote ? quote : null}/>
            <RequestForQuote
              onClick={onRFQButtonClicked}
              total={
                quote && quote.formattedTotalPrice
                  ? quote.formattedTotalPrice
                  : ""
              }
              quote={quote ? quote : null}
              isEditable={true}
              itemChanges={itemChanges}
              acctInfo={acctInfo}
            />
          </div>

        </div>
      </div>
    </>
  );
}

export default RFQHome;
